import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosAuth from "../../../axiosAuth";

export interface TlmTopic {
  topic_id: string;
  tlmMasterId: string;
  name: string;
  curriculumTopic: string;
  isEligible: boolean;
}

export interface SubModule {
  sub_module_id: string;
  sub_module_name: string;
  isEligible: boolean;
  tlm_topics: TlmTopic[];
}

export interface Module {
  module_id: string;
  module_name: string;
  isEligible: boolean;
  sub_modules: SubModule[];
}

export interface CurriculumGrade {
  class_id: string;
  curriculum: {
    curriculum_id: string;
    curriculum_name: string;
    curriculum_level: string;
    curriculum_grade: string;
    curriculum_description: string;
  };
  year: string;
  isEligible: boolean;
  modules: Module[];
}

export interface CurriculumManagementResponse {
  success: boolean;
  data: any;
  message?: string;
}

export interface CurriculumManagementQueryParams {
  schoolId: string;
}

const fetchCurriculumManagement = async (params: CurriculumManagementQueryParams) => {
  const { schoolId } = params;
  const response = await axiosAuth.get<CurriculumManagementResponse>(
    `/v1/school/crm/curriculum-management/${schoolId}/`
  );
  return response.data;
};

export const useGetCurriculumManagementQuery = (
  params: CurriculumManagementQueryParams,
  queryOptions?: Omit<
    UseQueryOptions<
      CurriculumManagementResponse,
      Error,
      CurriculumManagementResponse,
      ["grade-management", CurriculumManagementQueryParams]
    >,
    "queryKey" | "queryFn"
  >
) =>
  useQuery<CurriculumManagementResponse, Error, CurriculumManagementResponse, ["grade-management", CurriculumManagementQueryParams]>({
    queryKey: ["grade-management", params],
    queryFn: () => fetchCurriculumManagement(params),
    enabled: !!params.schoolId,
    ...(queryOptions || {}),
  });
